<template>
  <div class="regInfoBox">
    <auth-logo />
    <!-- 提交 -->
    <div class="formBox">
      <div class="inputBox lockBox">
        <input
          class="username"
          v-model="phoneNumber"
          type="text"
          :disabled="true"
          v-if="registerType == 1"
        />
        <input
          class="username"
          v-model="email"
          type="text"
          :disabled="true"
          v-if="registerType == 2"
        />
      </div>
      <div class="inputBox">
        <input
          class="password"
          v-model="password"
          :type="showPassword ? 'text' : 'password'"
          :placeholder="$t.auth.inputPaw"
        />
        <van-icon
          name="eye-o"
          v-if="showPassword"
          @click="showPassword = !showPassword"
        />
        <van-icon
          name="closed-eye"
          v-else
          @click="showPassword = !showPassword"
        />
      </div>
      <p class="inputInfo">{{ $t.auth.pawInfo }}</p>
      <div :class="['inputBox', disabled ? 'lockBox' : '']">
        <input
          class="username"
          v-model="companyCode"
          type="text"
          :placeholder="$t.auth.inputCompanyCode"
          :disabled="disabled"
        />
      </div>
      <div class="sub" @click="sub">{{ $t.auth.confirm }}</div>
      <div class="next" @click="onlogin">{{ $t.auth.backLogin }}</div>
    </div>

    <auth-background />
  </div>
</template>
<script>
import AuthLogo from "./components/AuthLogo";
import AuthBackground from "./components/AuthBackground";
import md5 from "js-md5";

export default {
  name: "regInfo",
  components: {
    AuthLogo,
    AuthBackground,
  },
  data() {
    return {
      registerType: 1,
      verificationCode: "",
      phoneNumber: "",
      email: "",
      password: "",
      companyCode: "",
      disabled: false,
      showPassword: false,
    };
  },
  created() {
    const query = this.$route.query;
    if (query.VerificationCode) {
      this.registerType = query.RegisterType;
      this.verificationCode = query.VerificationCode;
      this.phoneNumber = query.PhoneNumber;
      this.email = query.Email;
    }
    if (query.CompanyCode) {
      this.disabled = true;
      this.companyCode = query.CompanyCode;
    }
  },
  methods: {
    onlogin() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "auth/login",
        name: "Login",
        query: [],
      });
    },
    sub() {
      if (this.password == "") {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.auth.correctError,
          type: "danger",
        });
        return false;
      } else {
        this.register();
      }
    },
    //注册b用户
    register() {
      this.$commonMethod.showLoading();
      let param = {
        PhoneNumber: this.phoneNumber,
        Email: this.email,
        Password: md5(this.password),
        VerificationCode: this.verificationCode,
        CompanyCode: this.companyCode,
        AccountType: this.registerType,
      };
      this.$api.user
        .userRegister(param)
        .then(() => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.auth.registerSuccess,
            type: "success",
          });
          this.onlogin();
          this.$commonMethod.hideLoading();
        })
        .catch((err) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: err.message,
            type: "danger",
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.regInfoBox {
  position: relative;
  min-height: 100vh;
  width: 100%;
  .formBox {
    width: 85%;
    position: relative;
    margin: 0 auto;
    .lockBox {
      background: rgb(0, 0, 0, 0.3);
      border-radius: 100px;
    }
    .inputBox {
      justify-content: space-between;
      align-items: center;
      margin-top: 18px;
      width: 100%;
      @include publicFlex;
      .username,
      .password {
        background: none;
        outline: none;
        border: none;
        -webkit-appearance: none; /*去除系统默认的样式*/
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /* 点击高亮的颜色*/
        color: #f3faf8;
        font-size: 0.8rem;
        width: 100%;
        height: 50px;
        line-height: 50px;
        border: 0.1rem solid #b9e1da;
        border-radius: 100px;
        padding: 0 1.5rem;
        box-sizing: border-box;
        &::placeholder {
          color: #f3faf8;
          font-size: 0.8rem;
        }
        &::-webkit-input-placeholder {
          color: #f3faf8;
          font-size: 0.8rem;
        }
      }
      .getCode,
      .codeInfo {
        outline: none;
        border: 0;
        height: 50px;
        width: 185px;
        background-color: #ffffff;
        color: #6dc093;
        font-size: 0.4rem;
        text-align: center;
        border-radius: 80px;
        overflow: hidden;
        margin-left: 5%;
      }
      .codeInfo {
        font-size: 1rem;
        line-height: 50px;
        background-color: #dcdcdc;
        color: #ffffff;
      }
      .van-icon {
        position: absolute;
        right: 5%;
        color: #ffffff;
      }
    }
    .inputInfo {
      font-size: 0.8rem;
      color: #f3faf8;
      padding: 0 30px;
      box-sizing: border-box;
    }
    .next {
      margin-top: 20px;
      width: 100%;
      border-radius: 50px;
      text-align: center;
      color: #fff;
      font-size: 14px;
    }
    .sub {
      margin-top: 20px;
      width: 100%;
      height: 50px;
      line-height: 50px;
      border-radius: 50px;
      color: #304156;
      text-align: center;
      font-size: 14px;
      background-color: #ffffff;
      font-weight: bold;
    }
  }
}
</style>
